import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeatureFlagCompany } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-flags-company-table',
  templateUrl: './flags-company-table.component.html',
    styleUrls: ['./flags-company-table.component.scss']
})
export class FlagsCompanyTableComponent {
  @Output() onRemoveCompany: EventEmitter<FeatureFlagCompany> = new EventEmitter<FeatureFlagCompany>();

  @Input() companies: FeatureFlagCompany[] = [];

  public removeCompany(company: FeatureFlagCompany) {
    this.onRemoveCompany.emit(company);
  }
}
